import { createSlice, PayloadAction, createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../utility/axiosInstance';
import {handleAxiosError} from "../../helpers/handleAxiosError";
interface SecurityRule {
    id: string;
    name: string;
    description: string;
    protocol: string;
    port_range_min: string;
    port_range_max: string;
    security_group_id: string;
    created_at: string;
    updated_at: string;
    [key: string]: any;
}

interface SecurityRulesState {
    data: SecurityRule[];
    status: 'idle' | 'loading' | 'succeeded' | 'failed';
    error: string | null;
}

const initialState: SecurityRulesState = {
    data: [],
    status: 'idle',
    error: null,
};

export const fetchSecurityGroupRules = createAsyncThunk(
    'securityRules/fetchSecurityGroupRules',
    async (_, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.get('/v1/security_groups/rules/list');
            return response.data;
        } catch (error) {
            console.error("Failed to fetch DNS:", error);
            return rejectWithValue(handleAxiosError(error));
        }
    }
);

const securityRulesSlice = createSlice({
    name: 'securityRules',
    initialState,
    reducers: {
        setSecurityRules: (state, action: PayloadAction<SecurityRule[]>) => {
            state.data = action.payload;
        },
        resetSecurityRules: () => initialState,
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchSecurityGroupRules.pending, (state) => {
                state.status = 'loading';
                state.error = null;
            })
            .addCase(fetchSecurityGroupRules.fulfilled, (state, action: PayloadAction<SecurityRule[]>) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchSecurityGroupRules.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload as string;
            });
    },
});

export const { setSecurityRules, resetSecurityRules } = securityRulesSlice.actions;
export default securityRulesSlice.reducer;